import React from 'react';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

import debounce from 'lodash/debounce'

export default class Note extends React.Component {


    componentDidMount() {
        const { fetchText, assessmentId, activityId, id} = this.props
        fetchText(assessmentId, activityId,id)
        
    }
//   onChange={(content, delta, source, editor) =>updateText(assessmentId, activityId,id,content)} 
    render() { 
        const { updateText, storeText, assessmentId, activityId,id, text } = this.props
        
        return <span>
            <ReactQuill value={text} 
                onKeyUp={(e) => { debounce(() => {console.log('key up') }, 2000) } }
                onChange={(content, delta, source, editor) =>updateText(assessmentId, activityId,id,content)}
            /></span>
    }

}



// WEBPACK FOOTER //
// ./src/modules/notes/components/index.js